/**
 * The one-shot router state that opens Omat tiedot on a sub-view without an
 * address of its own (D-PD-010, 057 research R6). Only the fee view can be
 * opened this way; any other value is ignored, never cast.
 */

export interface ProfileNavigationState {
  readonly profileView: 'fee';
}

export const FEE_VIEW_HANDOFF: ProfileNavigationState = { profileView: 'fee' };

export function isFeeViewHandoff(state: unknown): state is ProfileNavigationState {
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as { profileView?: unknown }).profileView === 'fee'
  );
}
